import React, { useRef, useState } from "react";
import GuarantorCard from "./guarantor-card/GuarantorCard";
import UserModal from "../../common/user-modal/UserModal";
import { motion } from "framer-motion";
import { postApi } from "../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../../utils/toastify-message/ToastifyMessage";
import GuarantorInfo from "./guarantor-info/GuarantorInfo";
import DeleteGuarantorModal from "./guarantor-modal/DeleteGuarantorModal";

function Guarantor({ data, reGetData }) {
  console.log(data?.loanGuarantors);

  const userRef = useRef();
  const deleteUserRef = useRef();

  const openModal = () => {
    userRef.current.showModal();
  };

  const handleUser = (user) => {
    console.log(user);
    if (user) {
      addGuarantor(user);
    }
  };

  const addGuarantor = async (user) => {
    const path = `admin/loans/${data?._id}/loanGuarantors`;
    const body = {
      name: user?.name || "",
      nationalId: user?.nationalId || "",
      referrerUserNationalId: user?.referrerUserNationalId || "",
      job: user?.job || "",
      jobDescription: user?.jobDescription || "",
      bankAccountId: user?.bankAccountId || "",
      mobile: user?.mobile || "",
    };
    try {
      await postApi({ path, body });
      reGetData();
      successMessage("اطلاعات کاربر با موفقیت ویرایش شد.");
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  const [userInfo, setUserInfo] = useState(null);
  const [userData, setUserData] = useState(null);

  const deleteUser = (userData) => {
    setUserData(userData);
    deleteUserRef.current.showModal();
  };
  return (
    <>
      <UserModal ref={userRef} handleUser={handleUser} />
      <DeleteGuarantorModal
        ref={deleteUserRef}
        allData={data}
        data={userData}
        reGetData={reGetData}
      />

      {userInfo ? (
        <GuarantorInfo
          data={userInfo}
          allData={data}
          setUserInfo={setUserInfo}
          reGetData={reGetData}
        />
      ) : (
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.5,
            // ease: [0, 0.71, 0.2, 1.01]
          }}
          className="w-11/12 mx-auto  border border-gray-200 rounded-lg my-6 bg-white dark:bg-[#060d26] shadow-sm p-6"
        >
          <div className="flex items-center justify-between mb-4">
            <h3>لیست ضامن ها</h3>
            <button
              onClick={openModal}
              type="button"
              class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              افزودن ضامن
            </button>
          </div>

          {data?.loanGuarantors?.length ? (
            data?.loanGuarantors.map((item) => {
              return (
                <GuarantorCard
                  data={item}
                  setUserInfo={setUserInfo}
                  deleteUser={deleteUser}
                />
              );
            })
          ) : (
            <p className="w-full py-2 flex justify-center items-center text-gray-800 dark:text-white">
              هیچ ضامن ثبت شده ای وجود ندارد.
            </p>
          )}
        </motion.div>
      )}
    </>
  );
}

export default Guarantor;
